
import React from 'react';
import { Dialog, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { getReportDialogContent } from "./ReportDialog";
import { ReportFormData } from "@/components/ReportForm/formSchema";

interface ReportIntroductionProps {
  isDialogOpen: boolean;
  setIsDialogOpen: (isOpen: boolean) => void;
  isSuccess: boolean;
  onFormSubmit: (data: ReportFormData) => void;
  isLoading: boolean;
  title?: string;
  pdfPath?: string;
}

export const ReportIntroduction: React.FC<ReportIntroductionProps> = ({
  isDialogOpen,
  setIsDialogOpen,
  isSuccess,
  onFormSubmit,
  isLoading,
  title = "AI in the Legal Industry: Real-World Impact",
  pdfPath
}) => {
  return (
    <div className="mb-12">
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
        {title}
      </h1>
      
      <div className="mb-8">
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
          <DialogTrigger asChild>
            <Button className="flex items-center gap-2">
              <Download size={18} />
              Get the Report
            </Button>
          </DialogTrigger>
          {getReportDialogContent(isSuccess, onFormSubmit, isLoading, pdfPath)}
        </Dialog>
      </div>
    </div>
  );
};

export default ReportIntroduction;
